



























































































































































import {
  defineComponent,
  useContext,
  useStatic,
  computed,
} from '@nuxtjs/composition-api'

export default defineComponent({
  layout: 'minimal',
  setup() {
    const { $content } = useContext()

    const explanation = useStatic(() =>
      $content('krisenintervention/explanation').fetch<any>()
    , undefined, 'kriesen-1')

    const fileData = useStatic(() => $content('downloads').fetch<any>(), undefined, 'kriesen-2')

    const data = computed(() => {
      if (fileData.value === null) {
        return { files: [], folders: [] }
      } else {
        return (
          fileData.value.folders?.Krisenintervention || {
            files: [],
            folders: [],
          }
        )
      }
    })

    return {
      explanation,
      data
    }
  },

  head: {
    title: 'Kinder- und Jugendschutz – gibt es einen Notfall?',
    meta: [
      {
        hid: 'description',
        name: 'description',
        content:
          'Jugendschutz, Kindeswohl und Krisenintervention – hier findest du für alle Notfälle Ansprechpartner und weitere Informationen',
      },
      // Open Graph
      {
        hid: 'og:title',
        property: 'og:title',
        content: 'Kinder- und Jugendschutz – gibt es einen Notfall?',
      },
      {
        hid: 'og:description',
        property: 'og:description',
        content:
          'Jugendschutz, Kindeswohl und Krisenintervention – hier findest du für alle Notfälle Ansprechpartner und weitere Informationen',
      },
      // Twitter Card
      {
        hid: 'twitter:title',
        name: 'twitter:title',
        content: 'Kinder- und Jugendschutz – gibt es einen Notfall?',
      },
      {
        hid: 'twitter:description',
        name: 'twitter:description',
        content:
          'Jugendschutz, Kindeswohl und Krisenintervention – hier findest du für alle Notfälle Ansprechpartner und weitere Informationen',
      },
    ],
    link: [
      {
        rel: 'canonical',
        href: 'https://www.ec-nordbund.de/krisenintervention',
        hid: 'canonical',
      },
    ],
  },
})
